<div class="page-contents">
  <div id='levelOne' class="blockContainer flexbox-style-one">
    <div class="h-100">
      <div class="breadcrumbWrapper">
        <!-- {{title}} -->
        <app-breadcrumb></app-breadcrumb>
      </div>

      <div class="combination-loader">
        <div class="cmsaccess-container float-left">
          <div class="page-title-wrapper">
            <div class="title blade-title-font">
              CMS Access
            </div>
            <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/admin']">close</i>
          </div>

          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../../images/new_ui/filter.png">
            </div>
            <input class="searchInput ng-untouched ng-pristine ng-valid" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" type="text" (input)="searchCMS($event)">
          </div>

          <!-- <div class="clearfix"></div> -->
          <!-- <div style="border: 0.5px solid #E6E6E6;margin: 15px 0px"></div> -->
          <div class="top-divider"></div>

          <table class="table access-table">
            <thead>
              <tr>
                <th class="text-uppercase">Page</th>
                <th class="text-uppercase text-center">Manage</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cms of activeMasterCMS;let i = index">
                <td>
                  <p>{{cms?.title}}</p>
                </td>
                <td class="text-center manage-button-width">
                  <button type="button" class="button button-red button-mid"
                    (click)="selectedCMS = cms; isManageOwners = true; isManageCont = false;">Owner</button>
                  <button type="button" class="button button-red button-mid"
                    (click)="selectedCMS = cms; isManageCont = true; isManageOwners = false">Contributor</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>



        <div *ngIf="isManageOwners" class="cmsaccess-user-container float-left">
          <div class="page-title-wrapper">
            <div class="title blade-title-font">
              Manage Owners
            </div>
            <i class="material-icons closebutton-pullfloat-right" (click)="isManageOwners = false">close</i>
          </div> 
          <div class="clearfix"></div>
          <table class="table user-table">
            <tr *ngFor="let usr of selectedCMS?.owners;let i = index">
              <td>{{usr.userName}} - {{usr.accountId}}</td>
              <td class="width-x14">
                <button [disabled]="selectedCMS?.owners?.length < 2" (click)="removeUser('owner', i)"
                  class="btn btn-link p-0 line-height-0">
                  <img src="../../images/new_ui/cart-delete-hover.png" class="cursor-pointer height-x14">
                </button>
              </td>
            </tr>
          </table>
          <button id="saveButton" type="button" class="button button-red button-large w-100" (click)="saveCms()">Save</button>

          <br><br>
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../../images/new_ui/searchIcon-gray.png">
            </div>
            <input class="searchInput ng-untouched ng-pristine ng-valid" (input)="searchUser('owner', $event)"
              placeholder="Search" onfocus="this.placeholder=''" onblur="this.placeholder='Search'" type="text">
          </div>
          <br>
          <ul class="list-group list-group-flush">
            <ng-container *ngFor="let usr of searchOwnerUsers">
              <ng-container *ngIf="!checkIfExists('owner', usr)">
                <li class="list-group-item cursor-pointer" (click)="addUser('owner', usr)">
                  <!-- {{usr.out_login_id}} - {{usr.out_accountcode}} -->
                  <div class="color-red">{{usr.out_login_id}}</div>
                  Name: {{usr.out_first_name}} {{usr.out_surname}}
                </li>
              </ng-container>
            </ng-container>
          </ul>

          <div class="clearfix"></div>
        </div>

        <div *ngIf="isManageCont" class="cmsaccess-user-container float-left">
          <div class="page-title-wrapper">
            <div class="title blade-title-font">
              Manage Contributors
            </div>
            <i class="material-icons closebutton-pullfloat-right" (click)="isManageCont = false">close</i>
          </div>
          <div class="clearfix"></div>
          <table class="table user-table">
            <tr *ngFor="let usr of selectedCMS?.contributors;let i = index">
              <td>{{usr.userName}} - {{usr.accountId}}</td>
              <td class="width-x14">
                <button (click)="removeUser('contr', i)" class="btn btn-link p-0 line-height-0">
                  <img src="../../images/new_ui/cart-delete-hover.png" class="cursor-pointer height-x14">
                </button>
              </td>
            </tr>
          </table>
          <button id="saveButton" type="button" class="button button-red button-large w-100" (click)="saveCms()">Save</button>

          <br><br>
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../../images/new_ui/searchIcon-gray.png">
            </div>
            <input class="searchInput ng-untouched ng-pristine ng-valid" (input)="searchUser('contr', $event)"
              placeholder="Search" onfocus="this.placeholder=''" onblur="this.placeholder='Search'" type="text">
          </div>
          <br>
          <ul class="list-group list-group-flush">
            <ng-container *ngFor="let usr of searchContrUsers">
              <ng-container *ngIf="!checkIfExists('contr', usr) && !checkIfExists('owner', usr)">
                <li class="list-group-item cursor-pointer" (click)="addUser('contr', usr)">
                  <div class="color-red">{{usr.out_login_id}}</div>
                  Name: {{usr.out_first_name}} {{usr.out_surname}}
                </li>
              </ng-container>
            </ng-container>
          </ul>

          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</div>
